import { useEffect } from "react";

import { useSnackbar } from "notistack";

import { trpc } from "../../../common/helpers/trpc";

import { PDFContentViewer } from "./PDFContentViewer";
import { PDFPreview } from "./PDFPreview";

import { useBreakpointLogger } from "@/common/hooks/useBreakpointLogger";
import { useTranslate } from "@/common/hooks/useTranslate";
import { GetPreviewCouponInHTMLInput } from "@/common/types/trpc";

interface CouponPDFPreviewProps {
  getPreviewCouponInHtmlInput: GetPreviewCouponInHTMLInput;
  width?: number;
  height?: number;
}

export const CouponPDFPreview = ({
  getPreviewCouponInHtmlInput,
  width = 1275,
  height = 1650,
}: CouponPDFPreviewProps) => {
  const breakpoint = useBreakpointLogger();
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslate();
  const { data, isLoading, isError } = trpc.getPreviewCouponInHTML.useQuery(getPreviewCouponInHtmlInput);

  useEffect(() => {
    if (isError) {
      enqueueSnackbar(t("common", "unknownError", { code: 120 }), { vibe: "danger" });
    }
  }, [isError, enqueueSnackbar, t]);

  const couponHtml = data;
  if (!couponHtml) {
    return null;
  }

  return (
    <PDFPreview dataTest="preview-coupon-iframe" title="Coupon Preview">
      <PDFContentViewer
        html={couponHtml}
        breakpoint={breakpoint}
        isSkeleton={isLoading}
        rounded
        scaleSettings={{
          xl: 0.5,
          lg: 0.4,
          md: 0.33,
          xs: 0.29,
        }}
        width={width}
        height={height}
      />
    </PDFPreview>
  );
};
